<mat-card appearance="raised">
  <mat-card-header class="card-header">
    <mat-card-title>Accounts</mat-card-title>
    <button mat-icon-button
            matTooltip="Add"
            *ngIf="edit && (canAddLoans || canAddPendingLoans)"
            [matMenuTriggerFor]="menu">
      <mat-icon>add_circle</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item
              (click)="assignLoans()"
              *ngIf="canAddLoans">
        <span>Add account</span>
      </button>
      <button mat-menu-item
              (click)="assignPendingLoans()"
              *ngIf="canAddPendingLoans">
        <span>Add pending account</span>
      </button>
    </mat-menu>
  </mat-card-header>
  <mat-card-content class="card-content">
    <mat-list *ngIf="loans?.length > 0">
      <mat-list-item *ngFor="let loan of loans; let i = index;"
                     class="item">
        <span matListItemIcon
              class="item__icon">{{i+1}}</span>
        <span matListItemTitle>
          <a class="default-link"
             [routerLink]="accountDetailsLink(loan)">{{loan.loanNumber}}
          </a>
        </span>
        <span matListItemLine>{{loan.entityName}}</span>
        <span matListItemLine>{{getStatus(loan.status)}} - {{loan.productName}}</span>
        <span matListItemMeta
              class="meta">
          <mat-progress-bar class="meta__progress mat-progress-bar-xl"
                            *ngIf="getUtilization(loan.loanInfo); let utilization"
                            matTooltip="Utilization {{utilization}}%"
                            mode="determinate"
                            [color]="getProgressColor(utilization)"
                            [value]="utilization">
          </mat-progress-bar>
          <button class="mat-icon-button-sm delete-icon"
                  mat-icon-button
                  matTooltip="Delete"
                  *ngIf="edit"
                  (click)="deleteLoan(loan)">
            <mat-icon>delete</mat-icon>
          </button>
        </span>
      </mat-list-item>
    </mat-list>

    <span *ngIf="pendingLoans?.length"
          class="label">Pending accounts</span>
    <mat-list *ngIf="pendingLoans?.length > 0">
      <mat-list-item *ngFor="let loan of pendingLoans; let i = index;"
                     class="item">
        <span matListItemIcon
              class="item__icon">{{i+1}}</span>
        <span matListItemTitle>
          <a class="default-link"
             [routerLink]="accountDetailsLink(loan)">{{loan.loanNumber}}
          </a>
        </span>
        <span matListItemLine
              *ngIf="loan?.businessName">{{loan.businessName}}</span>
        <span matListItemLine>{{getStatus(loan.status)}} - {{loan.productName}}</span>
        <span matListItemMeta
              class="meta">
          <mat-progress-bar class="meta__progress mat-progress-bar-xl"
                            *ngIf="getUtilization(loan.loanInfo); let utilization"
                            matTooltip="Utilization {{utilization}}%"
                            mode="determinate"
                            [color]="getProgressColor(utilization)"
                            [value]="utilization">
          </mat-progress-bar>
          <button class="mat-icon-button-sm delete-icon"
                  mat-icon-button
                  matTooltip="Delete"
                  *ngIf="edit"
                  (click)="deleteLoan(loan)">
            <mat-icon>delete</mat-icon>
          </button>
        </span>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>
